import React from "react";
import Link from "components/link/link";

export function AmpMobileMenu(props: any) {
  const { items } = props;

  return items
    ? items.map((menuItem: any, index: any) => {
        const { url, title, items: itemItems } = menuItem;

        return (
          <ul className="mobile-menu" key={`mobile-menu-item-${index}`}>
            <li className="mobile-menu__item">
              <Link className="mobile-menu__link" href={url}>
                {title}
              </Link>

              {itemItems ? (
                <div className="mobile-menu__submenu">
                  <ul className="mobile-submenu">
                    {itemItems.map((item: any, itemItemsIndex: any) => {
                      const { url: itemUrl, title: itemTitle } = item;

                      return (
                        <li
                          className="mobile-submenu__item"
                          key={`mobile-submenu-item-${itemItemsIndex}`}
                        >
                          <Link className="mobile-submenu__link" href={itemUrl}>
                            {itemTitle}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : null}
            </li>
          </ul>
        );
      })
    : null;
}

export default AmpMobileMenu;
